import baseUrl from "./base"
import {postRequest, postRequestCustomHeaders, getRequest, getRequestCustomHeaders} from "./common"


const record15Api = {
    //查詢展館和對應公司的申請記錄
    "queryRecord14CompanyModelByPage": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record15/queryRecord14CompanyModelByPage`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                id: null,  //展馆id
                companycode: null,
                addinfo17: null,   //類型 0展館 1商場 -1島
                pageNum: 1,
                pageSize: 10
            }
        }
    },
    //查詢展館和對應的參展記錄
    "queryAdditionalrecord15HallModelByPage": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record15/queryAdditionalrecord15HallModelByPage`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                companycode: null,
                addinfo13: null,  //類型 0展館 1商場 -1島
                pageNum: 1,
                pageSize: 10
            }
        }
    },
    //企業申請
    "submitRecord15": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record15/submitRecord15`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                additionalrecord15: {
                    companycode: null,
                    login: null,
                    updatedid: null,
                    addinfo10: null,
                    addinfo12: null,  //json
                    addinfo13: null,  //類別  0展館 1商場 -1島
                },
                record16List: []
            }
        }
    },
    //修改企業申請
    "editRecord15": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record15/editRecord15`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                id: null,
                addinfo10: null,
                addinfo12: null,  //json
                record16List: null
            }
        }
    },
    //修改申请记录的订单号
    "updateRecord15Commonref": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record15/updateAdditionalrecord15`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                id: null,
                addinfo11: null,  //订单号
            }
        }
    },
    //通過展會申請記錄
    "updateRecordStats": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record15/updateAdditionalrecord15`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                id: null,
                recordno: null,  //0申請中 -1已通過
            }
        }
    },
    //關鍵字查詢參展記錄和對應的公司信息
    "getRecord15ListandCompany": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record15/getRecord15ListandCompany`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                recordno: -1,
                recordname: null,  //公司名的關鍵字
                updatedid: null,  //展館號
            }
        }
    },
    //關鍵字分頁查詢參展記錄和對應的公司信息
    "getRecord15ListandCompanyByPage": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record15/getRecord15ListandCompanyByPage`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                recordno: -1,
                recordname: null,  //公司名的關鍵字
                updatedid: null,  //展館號
                pageNum: 1,
                pageSize: 10
            }
        }
    },
    //查詢對應展館每個展臺的狀態
    "queryAdditionalrecord15PositionStatus": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record15/queryAdditionalrecord15PositionStatus`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                updatedid: null,  //展館號
            }
        }
    },
    //查詢對應展館每個展臺的狀態
    "queryAdditionalrecord15Position": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record15/queryAdditionalrecord15Position`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                id: null,  //id
            }
        }
    },
    //添加展位預定記錄
    "insertNewRecord15": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record15/insertNewRecord15`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                updatedid: null,  //展館號
                addinfo1: null, //樓層
                addinfo2: null //展位號
            }
        }
    },
    //刪除展位記錄
    "delAdditionalrecord15": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record15/delAdditionalrecord15`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                id: null
            }
        }
    },
    //添加參展公司
    "addHallCompany": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record15/insertAdditionalrecord15`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                addinfo1: null,   //樓層號
                addinfo2: null,   //門牌號
                companycode: null,   //邀請公司的companycode
                updatedid: null,   //展會Id
                historydatetime: null,   //操作時間
                login: null,   //操作者的login
                recordno: -1   //自動通過
            }
        }
    },
    //移動展臺位置
    "updateRecord15Position": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record15/updateRecord15Position`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                addinfo1: null,   //樓層號
                addinfo2: null,   //門牌號
                updatedid: null,   //展會Id
                id: null
            }
        }
    },
    //分頁查詢島嶼商家
    "queryRecord15CompanyModel": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record15/queryRecord15CompanyModel`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                pageNum: 1,
                pageSize: 10,
                updatedid: null,   //島嶼Id
                addinfo40: null   //搜索關鍵字
            }
        }
    },
    //修改申請狀態
    "updateRecord15Stats": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record15/updateAdditionalrecord15`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                id: null,
                recordno: null
            }
        }
    },
    "queryMaxStoreNumber": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record15/queryMaxStoreNumber`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                updatedid: null
            }
        }
    },
    "insertAdditionalrecord15": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record15/insertAdditionalrecord15`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                addinfo1: null,   //樓層號
                addinfo2: null,   //門牌號
                companycode: null,   //邀請公司的companycode
                updatedid: null,   //展會Id
                historydatetime: null,   //操作時間
                login: null,   //操作者的login
                recordno: -1   //自動通過
            }
        }
    }
}

export default record15Api